import React__default, { useState } from 'react';
import * as index from '../Icons/index.js';

const Icon = ({ icon, color = '#000000', hoverColor = color, iconSize = 1, hasBoundingBox = false, boundingBoxWidth = 20, boundingBoxHeight = 20, boundingBoxRadius = 0, boundingBoxBorder = 0, boundingBoxBorderColor = 'transparent', boundingBoxBackgroundColor = 'transparent', }) => {
    const IconComponent = index[icon];
    const [hover, setHover] = useState(false);
    if (hasBoundingBox) {
        return (React__default.createElement("div", { style: {
                width: boundingBoxWidth,
                height: boundingBoxHeight,
                padding: hasBoundingBox ? 5 : 0,
                backgroundColor: boundingBoxBackgroundColor,
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: boundingBoxRadius,
                borderStyle: boundingBoxBorder > 0 ? 'solid' : 'none',
                borderWidth: boundingBoxBorder,
                borderColor: boundingBoxBorderColor,
            }, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) },
            React__default.createElement(IconComponent, { fill: hover ? hoverColor : color, size: iconSize })));
    }
    else {
        return (React__default.createElement("span", { onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) },
            React__default.createElement(IconComponent, { fill: hover ? hoverColor : color, size: iconSize })));
    }
};

export { Icon as default };
//# sourceMappingURL=Icon.js.map
